/* eslint-disable no-return-assign */
/* eslint-disable spaced-comment */
/* eslint-disable max-classes-per-file */
/* eslint-disable no-var */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable dot-notation */
import { LiteralObject } from 'viggo-sistemas-core-web';
import { SettingsPrimeirosPassos } from './primeiros_passos/settings_primeiros_passos';

class TipoContasAtraso {
  result: string;
  constructor(public enumValue: string) {
    if (enumValue === 'RESTRITO') {
      this.result = 'RESTRITO';
    } else if (enumValue === 'LIBERADO_AVISTA') {
      this.result = 'LIBERADO_AVISTA';
    } else if (enumValue === 'LIBERADO_FULL') {
      this.result = 'LIBERADO_FULL';
    } else {
      this.result = 'UNKNOWN';
    }
  }
}
class TipoOperacoesFinanceiro {
  result: string;
  constructor(public enumValue: string) {
    if (enumValue === 'COMPR_MERC_REV') {
      this.result = 'COMPR_MERC_REV';
    } else if (enumValue === 'COMPR_MERC_CONS') {
      this.result = 'COMPR_MERC_CONS';
    } else if (enumValue === 'CONS_SERV') {
      this.result = 'CONS_SERV';
    } else if (enumValue === 'VEND_MERC') {
      this.result = 'VEND_MERC';
    } else if (enumValue === 'FAB_PROD') {
      this.result = 'FAB_PROD';
    } else {
      this.result = 'UNKNOWN';
    }
  }
}

class TipoBaixaEstoqueMateriaPrima {
  result: string;
  constructor(public enumValue: string) {
    if (enumValue === 'PRODUZIR_PEDIDO') {
      this.result = 'PRODUZIR_PEDIDO';
    } else if (enumValue === 'CRIAR_PEDIDO') {
      this.result = 'CRIAR_PEDIDO';
    } else {
      this.result = 'UNKNOWN';
    }
  }
}

class TipoValorMinimoProduto {
  result: string;
  constructor(public enumValue: string) {
    if (enumValue === 'TABELA_PRECO') {
      this.result = 'TABELA_PRECO';
    } else if (enumValue === 'PRODUTO') {
      this.result = 'PRODUTO';
    } else {
      this.result = 'UNKNOWN';
    }
  }
}

class TipoReajusteEstoque {
  result: string;
  constructor(public enumValue: string) {
    if (enumValue === 'ZERAR_ESTOQUE') {
      this.result = 'ZERAR_ESTOQUE';
    } else if (enumValue === 'PERMITIR_REAJUSTE') {
      this.result = 'PERMITIR_REAJUSTE';
    } else {
      this.result = 'UNKNOWN';
    }
  }
}

export class ValidadorSettingsDomain {
  //MATERIA_PRIMA
  controle_estoque_materia = false;
  taxa_conversao = 0;
  baixar_estoque = null;
  // reajuste_estoque_materia_variacao = null;

  //PRODUTO
  valor_minimo = null;
  controle_estoque_produto = false;
  // reajuste_estoque_produto_variacao = null;

  //CUSTOS_EMPRESA
  custo_administrativo = 0;
  custo_operacional = 0;
  custo_fiscal = 0;
  media_producao = 0;
  margem_lucro_padrao = 0;
  margem_lucro_porcentagem = false;
  valor_pauta = 0;
  aliquota_regime = 0;

  //CAIXA_PDV
  bloquear_desconto = false;
  acrescimo_max = 100;
  desconto_max = 100;
  registro_caixa = false;
  forcar_fechamento_caixa = false;
  fechamento_as_cegas = false;
  conferencia_auto = false;

  //PACOTE_CUSTOMIZADO
  valor_aquisicao = 0;
  valor_recorrencia = 0;
  customizado = false;
  papeis = [];

  // CONTAS_RECEBER
  contas_atraso = null;
  taxa_juros_mes = 0;
  dias_tolerancia_juros = 0;
  gerar_comprovante_pagto = false;

  // CLIENTES
  limite_credito = false;

  // PARCEIRO
  saldo_credito = false;

  // EXPEDIÇÃO
  obrigar_pagto_faturar = false;

  // PRODUCAO
  dias_alerta = 0;
  meta_producao_diaria = 0;

  //FINANCEIRO
  operacao_padrao_receber_caixa = null;
  operacao_padrao_receber_fabrica = null;
  operacao_padrao_pagar = null;
  operacoes = [];
  observables_fin = [];
  observables_centro = [];

  constructor(
    public domain_settings: LiteralObject,
    public application_settings = {},
    public planoSelecionado = 'PRODUCAO'
  ) {
    const domain_regras = domain_settings['regras'] ?? {};
    const domain_preco_pacote = domain_settings['preco_pacote'] ?? {};
    const application_preco_pacote = application_settings['preco_pacote'] ?? {};

    const controle = domain_regras['controle'] ?? {};
    const caixa_pdv = domain_regras['caixa_pdv'] ?? {};
    const financeiro = domain_regras['config_financeira'] ?? {};
    const materia_prima = controle['materia_prima'] ?? {};
    const produto = controle['produto'] ?? {};
    const conta_receber = controle['conta_receber'] ?? {};
    const cliente = controle['cliente'] ?? {};
    const parceiro = controle['parceiro'] ?? {};
    const custos_empresa = controle['custos_empresa'] ?? {};
    const expedicao = controle['expedicao'] ?? {};
    const producao = controle['producao'] ?? {};

    //MATERIA PRIMA
    this.controle_estoque_materia = materia_prima['controle_estoque'] ?? false;
    this.taxa_conversao = materia_prima['taxa_conversao'] ?? 0;
    this.baixar_estoque = this.getTipoMateriaPrimaBaixaEstoque(materia_prima);
    // this.reajuste_estoque_materia_variacao = this.getTipoReajusteEstoque(
    //   materia_prima
    // );

    //PRODUTO
    this.controle_estoque_produto = produto['controle_estoque'] ?? false;
    this.valor_minimo = this.getTipoProdutoValorMinimo(produto);
    // this.reajuste_estoque_produto_variacao = this.getTipoReajusteEstoque(
    //   produto
    // );

    //CUSTOS_EMPRESA
    this.custo_administrativo = custos_empresa['custo_administrativo'] ?? 0;
    this.custo_operacional = custos_empresa['custo_operacional'] ?? 0;
    this.custo_fiscal = custos_empresa['custo_fiscal'] ?? 0;
    this.media_producao = custos_empresa['media_producao'] ?? 0;
    this.margem_lucro_padrao = custos_empresa['margem_lucro_padrao'] ?? 0;
    this.margem_lucro_porcentagem =
      custos_empresa['margem_lucro_porcentagem'] ?? false;
    this.valor_pauta = custos_empresa['valor_pauta'] ?? 0;
    this.aliquota_regime = custos_empresa['aliquota_regime'] ?? 0;

    //CAIXA_PDV
    this.bloquear_desconto = caixa_pdv['bloquear_desconto'] ?? false;
    this.acrescimo_max = caixa_pdv['acrescimo_max'] ?? 100;
    this.desconto_max = caixa_pdv['desconto_max'] ?? 100;
    this.registro_caixa = caixa_pdv['registro_caixa'] ?? false;
    this.forcar_fechamento_caixa =
      caixa_pdv['forcar_fechamento_caixa'] ?? false;
    this.fechamento_as_cegas = caixa_pdv['fechamento_as_cegas'] ?? false;
    this.conferencia_auto = caixa_pdv['conferencia_auto'] ?? false;

    //CONTA_RECEBER
    this.contas_atraso = this.getTipoContasAtraso(conta_receber);
    this.taxa_juros_mes = conta_receber['taxa_juros_mes'] ?? 0;
    this.dias_tolerancia_juros = conta_receber['dias_tolerancia_juros'] ?? 0;
    this.gerar_comprovante_pagto = conta_receber['gerar_comprovante_pagto'] ?? 0;

    //CLIENTE
    this.limite_credito = cliente['limite_credito'] ?? false;

    // VENDEDOR
    this.saldo_credito = parceiro['saldo_credito'] ?? false;

    //EXPEDICAO
    this.obrigar_pagto_faturar = expedicao['obrigar_pagto_faturar'] ?? false;

    //PRODUCAO
    this.dias_alerta = producao['dias_alerta'] ?? 0;
    this.meta_producao_diaria = producao['meta_producao_diaria'] ?? 0;

    //FINANCEIRO
    this.operacao_padrao_pagar = this.getOperacaoPadrao(financeiro, 'PAGAR');
    this.operacao_padrao_receber_caixa = this.getOperacaoPadrao(
      financeiro,
      'RECEBER_CAIXA'
    );
    this.operacao_padrao_receber_fabrica = this.getOperacaoPadrao(
      financeiro,
      'RECEBER_FABRICA'
    );
    this.operacoes = financeiro['operacoes'] ?? [];
    this.observables_centro = financeiro['observables_centro'] ?? [];
    this.observables_fin = financeiro['observables_fin'] ?? [];

    //PACOTE CUSTOMIZADO
    this.customizado = domain_preco_pacote['customizado'] ?? false;
    this.valor_aquisicao = domain_preco_pacote['valor_aquisicao']
      ? domain_preco_pacote['valor_aquisicao']
      : application_preco_pacote['valor_aquisicao']
      ? application_preco_pacote['valor_aquisicao']
      : 0;
    this.valor_recorrencia = domain_preco_pacote['valor_recorrencia']
      ? domain_preco_pacote['valor_recorrencia']
      : application_preco_pacote['valor_recorrencia']
      ? application_preco_pacote['valor_recorrencia']
      : 0;
    this.papeis = domain_preco_pacote['papeis']
      ? this.getPrecoPacotePapeis(domain_preco_pacote)
      : application_preco_pacote['papeis']
      ? this.getPrecoPacotePapeis(application_preco_pacote)
      : [];
  }

  getTipoProdutoValorMinimo(settings) {
    var op = settings['valor_minimo'] ?? 'UNKNOWN';
    if (op === undefined) {
      op = 'UNKNOWN';
    }
    return new TipoValorMinimoProduto(op).result;
  }

  getTipoMateriaPrimaBaixaEstoque(settings) {
    var op = settings['baixar_estoque'] ?? 'UNKNOWN';
    if (op === undefined) {
      op = 'UNKNOWN';
    }
    return new TipoBaixaEstoqueMateriaPrima(op).result;
  }

  getTipoReajusteEstoque(settings) {
    var op = settings['reajuste_estoque_variacao'] ?? 'UNKNOWN';
    if (op === undefined) {
      op = 'UNKNOWN';
    }
    return new TipoReajusteEstoque(op).result;
  }

  getOperacaoPadrao(settings, type: string) {
    if (type === 'RECEBER_CAIXA') {
      var op_receber_caixa =
        settings['operacao_padrao_receber_caixa'] ?? 'UNKNOWN';
      if (op_receber_caixa === undefined) {
        op_receber_caixa = 'UNKNOWN';
      }
      return new TipoOperacoesFinanceiro(op_receber_caixa).result;
    } else if (type === 'RECEBER_FABRICA') {
      var op_receber_fabrica =
        settings['operacao_padrao_receber_fabrica'] ?? 'UNKNOWN';
      if (op_receber_fabrica === undefined) {
        op_receber_fabrica = 'UNKNOWN';
      }
      return new TipoOperacoesFinanceiro(op_receber_fabrica).result;
    } else {
      var op_pagar = settings['operacao_padrao_pagar'] ?? 'UNKNOWN';
      if (op_pagar === undefined) {
        op_pagar = 'UNKNOWN';
      }
      return new TipoOperacoesFinanceiro(op_pagar).result;
    }
  }

  getTipoContasAtraso(settings) {
    var op = settings['contas_atraso'] ?? 'UNKNOWN';
    if (op === undefined) {
      op = 'UNKNOWN';
    }
    return new TipoContasAtraso(op).result;
  }

  getPrecoPacotePapeis(settings) {
    var result = [];
    var papeis = settings['papeis'] ?? [];
    papeis.forEach(papel => {
      result.push({
        id: papel['id'] ?? '',
        nome: papel['nome'] ?? '',
        quantidade: papel['quantidade'] ?? 0,
        valor: papel['valor'] ?? 0
      });
    });
    return result;
  }

  getDomainSettingsBody(domain_settings) {
    return (domain_settings = {
      regras: {
        controle: {
          materia_prima: {
            controle_estoque: this.controle_estoque_materia,
            baixar_estoque: this.baixar_estoque,
            taxa_conversao: this.taxa_conversao,
            // reajuste_estoque_variacao: this.reajuste_estoque_materia_variacao
          },
          produto: {
            controle_estoque: this.controle_estoque_produto,
            valor_minimo: this.valor_minimo,
            // reajuste_estoque_variacao: this.reajuste_estoque_produto_variacao
          },
          cliente: {
            limite_credito: this.limite_credito
          },
          parceiro: {
            saldo_credito: this.saldo_credito
          },
          conta_receber: {
            contas_atraso: this.contas_atraso,
            taxa_juros_mes: this.taxa_juros_mes,
            dias_tolerancia_juros: this.dias_tolerancia_juros,
            gerar_comprovante_pagto: this.gerar_comprovante_pagto,
          },
          custos_empresa: {
            custo_administrativo: this.custo_administrativo,
            custo_operacional: this.custo_operacional,
            custo_fiscal: this.custo_fiscal,
            media_producao: this.media_producao,
            margem_lucro_padrao: this.margem_lucro_padrao,
            margem_lucro_porcentagem: this.margem_lucro_porcentagem,
            valor_pauta: this.valor_pauta,
            aliquota_regime: this.aliquota_regime
          },
          expedicao: {
            obrigar_pagto_faturar: this.obrigar_pagto_faturar
          },
          producao: {
            dias_alerta: this.dias_alerta,
            meta_producao_diaria: this.meta_producao_diaria
          }
        },
        caixa_pdv: {
          bloquear_desconto: this.bloquear_desconto,
          acrescimo_max: this.acrescimo_max,
          desconto_max: this.desconto_max,
          registro_caixa: this.registro_caixa,
          forcar_fechamento_caixa: this.forcar_fechamento_caixa,
          fechamento_as_cegas: this.fechamento_as_cegas,
          conferencia_auto: this.conferencia_auto
        },
        config_financeira: {
          operacoes: this.operacoes,
          operacao_padrao_pagar: this.operacao_padrao_pagar,
          operacao_padrao_receber_caixa: this.operacao_padrao_receber_caixa,
          operacao_padrao_receber_fabrica: this.operacao_padrao_receber_fabrica,
          observables_centro: this.observables_centro,
          observables_fin: this.observables_fin
        }
      },
      preco_pacote: {
        customizado: this.customizado,
        valor_aquisicao: this.valor_aquisicao,
        valor_recorrencia: this.valor_recorrencia,
        papeis: this.papeis
      },
      config_inicial: new SettingsPrimeirosPassos(
        domain_settings,
        this.application_settings,
        this.planoSelecionado
      ).getConfigInicialSettings(domain_settings)
    });
  }
}
